<template>
  <div>
    <modal-electronic-game
      ref="ModalElectronicGame"
      :siteid="$route.query.siteid"
    ></modal-electronic-game>
    <modal-electronic-big-game
      ref="ModalElectronicBigGame"
      :siteid="$route.query.siteid"
    ></modal-electronic-big-game>
    <lida-table
      :propscolumns="thecolumns"
      :data="items"
      :sortStatus="false"
    >
      <template v-slot:headerSelect>
        <Button
          type="warning"
          v-show="!sortSate"
          @click="sortSate = !sortSate"
        >修改遊戲開關</Button>
        <span v-show="sortSate">
          <Button
            type="error"
            @click="modifySiteElectronicGameMaker"
            :loading="sortSateLoading"
          >储存</Button>
        </span>
      </template>
    </lida-table>
    <!-- <div >
      <Button type="primary" @click="">取消</Button>
      <Button type="error"  @click="modifySiteElectronicGameMaker">修改</Button>
    </div>-->
  </div>
</template>
<script>
import triggerColumns from "@/mixins/triggerColumns.js"
import ModalElectronicBigGame from './ModalElectronicBigGame'
import ModalElectronicGame from './ModalElectronicGame'
import { mapGetters } from 'vuex'
export default {
  name: 'ElectronicGame',
  mixins: [triggerColumns],
  components: {
    ModalElectronicBigGame,
    ModalElectronicGame
  },
  data () {
    return {
      items: [],
    }
  },
  computed: {
    ...mapGetters(['getmember']),
    thecolumns () {
      return {
        gamehall: {
          title: '游戏商简称',
          key: 'gamehall',
          align: 'center',
          className: "infor-column",
        },
        idop: {
          title: '开启/关闭',
          key: 'title',
          align: 'center',
          renderHeader: (this.triggerHeaderIdop),
          render: (h, params) => this.triggerIdop(h, params, 'hallsid')
        },
        gamePJAllList: {
          title: '大項玩法开启',
          key: 'title',
          align: 'center',
          render: (h, params) => {
            const gameGearingClick = {
              click: () => this.$refs.ModalElectronicBigGame.trigger(params.row.hallsid)
            }
            return h('Button', {
              props: {
                type: 'warning',
                disabled: this.sortSateLoading || this.sortSate
              },
              on: gameGearingClick
            }, '玩法开启')
          }
        },
        indexNumber: {
          title: '玩法开启',
          key: 'idop',
          align: 'center',
          render: (h, params) => {
            const gameGearingClick = {
              click: () => this.$refs.ModalElectronicGame.trigger(params.row.hallsid)
            }
            return h('Button', {
              props: {
                type: 'warning',
                disabled: this.sortSateLoading || this.sortSate
              },
              on: gameGearingClick
            }, '玩法开启')
          }
        }
      }
    }
  },
  created () {
    this.getSiteElectronicGameMaker()
  },
  methods: {
    async getSiteElectronicGameMaker () {
      try {
        const res = await this.$axios.cq9.getSiteElectronicGameMaker(this.$route.query.siteid)
        if ('status' in res && res.status === 0) return
        this.items = res.map(it => {
          it.idop = Number(it.idop)
          it.idopText = it.idop ? '开启' : '关闭'
          it.defaultidop = it.idop
          return it
        })
      } catch (error) {
        console.log(error);
      }
    },
    async modifySiteElectronicGameMaker () {
      const obj = {
        loid: this.getmember.pid,
        stid: this.$route.query.siteid,
        hallsitem: this.modifyArray(this.items, (it) => ({ hallsid: it.hallsid, idop: it.idop }))
      }
      if (!obj.hallsitem.length) return this.sortSate = false;
      this.sortSateLoading = true
      try {
        const res = await this.$axios.cq9.modifySiteElectronicGameMaker(obj)
        if (res.status === 1) {
          this.$Message.success("已更改");
          this.getSiteElectronicGameMaker()
          this.sortSate = false;
        }
        this.sortSateLoading = false
      } catch (error) {
        console.log(error);
        this.$Message.error('cq9修改游戏商开关错误');
        this.sortSateLoading = false
      }
    }
  }
}
</script>